import { render } from "./DocumentViewer.vue?vue&type=template&id=4cf5cd09&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"

import "./DocumentViewer.vue?vue&type=style&index=0&id=4cf5cd09&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf5cd09"]])

export default __exports__